import { updateActionErrors } from './updateErrors';
import { AddPropertyMutation, DeletePropertyMutation, GetAllPropertiesUnitsTenants, GetPropertiesQuery, UpdatePropertyMutation } from '../../api/graphql/queries/property';
import {
    ADD_PROPERTY, UPDATE_PROPERTY, DELETE_PROPERTY, LOAD_PROPERTIES, LOAD_PROPERTIES_UNITS_TENANTS
} from '../actions/actionTypes';
import graphqlClient from '../../api/axios_interceptor';
import { showErrorModal, showLoading } from '../actions';
import { parseUnit } from './units';


export const parseProperty = (property) => ({
    propertyId: property.id,
    propertyName: property.name,
    numUnits: property.unitCount,
    city: property.city,
    address: property.addressStreet,
    waterRate: property.waterRate,
    electricityRate: property.electricityRate,
    mpesaShortcodeType: property.mpesaShortcode? property.mpesaShortcode.shortcodeType : "",
    mpesaShortcode: property.mpesaShortcode? property.mpesaShortcode.shortcode : "",
    tillNumber: property.mpesaShortcode && property.mpesaShortcode.tillNumber ? property.mpesaShortcode.tillNumber : "",
    penaltyType: property.propertyPenaltyType? property.propertyPenaltyType.toUpperCase(): "" ,
    fixedPenaltyAmount: property.fixedPenaltyAmount,
    percentagePenaltyAmount: property.percentagePenaltyAmount,
    automaticallyPenalize: property.automaticallyPenalize,
    penaltyDayOfMonth: property.penaltyDayOfMonth,
    managementFeeType: property.managementFeeType,
    managementFeeFixedAmount: property.managementFeeFixedAmount,
    managementFeePercentage: property.managementFeePercentage,
    taxRate: property.taxRate,
    otherRecurringBillsItems: property.otherRecurringBills ? JSON.parse(JSON.parse(property.otherRecurringBills)) : [],
    notes: property.notes,
    companyName: property.companyName,
    paymentInstructions: property.paymentInstructions,
    managementInvoices: property.managementInvoices ? property.managementInvoices : []
});

const fetchPropertiesUnitsTenantsMiddleware = async (action) => {
    let properties = {};
    let units = {};
    try {
        await graphqlClient({
            data: {
                query: GetAllPropertiesUnitsTenants()
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                queryResult.data.data.allPropertyUnitsTenantsData.properties.map((property) => (
                    properties[property.id] = {
                        ...parseProperty(property),
                        vacancies: property.vacancies,
                        units: {}
                    }
                ))
                queryResult.data.data.allPropertyUnitsTenantsData.units.map((unit) => (
                    units[unit.id] = { ...parseUnit(unit) }
                ))


                for (const [key, value] of Object.entries(units)) {
                    properties[value.propertyId]["units"][value.unitId] = {}
                }

                let initialData = { properties, units };
                action.payload = {
                    ...action.payload,
                    ...initialData
                }

            }
        })
    } catch (error) {
        console.error(error);
        let initialData = { properties, units };
        action.payload = {
            ...action.payload,
            ...initialData
        }
        action = updateActionErrors(action, error)
    }
    return action;
}

const propertiesMiddleware = storeAPI => next => async action => {
    let property = action.payload;

    switch (action.type) {
        case ADD_PROPERTY:
            try {
                const query = AddPropertyMutation(property.propertyName, property.numUnits, property.city, property.address,
                    property.waterRate, property.electricityRate, property.mpesaShortcode, property.mpesaShortcodeType, property.tillNumber,
                    property.penaltyType, property.fixedPenaltyAmount, property.percentagePenaltyAmount, property.automaticallyPenalize,
                    property.penaltyDayOfMonth, property.managementFeeType, property.managementFeeFixedAmount,
                    property.managementFeePercentage, property.taxRate, property.otherRecurringBillsItems,
                    property.notes, property.companyName, property.paymentInstructions, property.managementInvoices)
                await graphqlClient({
                    data: {
                        query
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else {
                        const propertyDetails = parseProperty(queryResult.data.data.addProperty.property);
                        let modPayload = {
                            ...action.payload,
                            ...propertyDetails,
                            vacancies: 0,
                            units: {}
                        }
                        action = {
                            ...action,
                            payload: modPayload
                        };
                    }
                });

            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;

        case UPDATE_PROPERTY:
            try {
                await graphqlClient({
                    data: {
                        query: UpdatePropertyMutation(property.propertyId, property.propertyName, property.numUnits, property.city,
                            property.address, property.waterRate, property.electricityRate, property.mpesaShortcode, property.mpesaShortcodeType,
                            property.tillNumber, property.penaltyType, property.fixedPenaltyAmount, property.percentagePenaltyAmount,
                            property.automaticallyPenalize, property.penaltyDayOfMonth, property.managementFeeType,
                            property.managementFeeFixedAmount, property.managementFeePercentage, property.taxRate, property.otherRecurringBillsItems,
                            property.notes, property.companyName, property.paymentInstructions, property.managementInvoices)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }else{
                        const propertyDetails = parseProperty(queryResult.data.data.updateProperty.property);
                        let modPayload = {
                            ...action.payload,
                            ...propertyDetails,
                            units: {}
                        }
                        action = {
                            ...action,
                            payload: modPayload
                        };
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }

            break;

        case DELETE_PROPERTY:
            try {
                await graphqlClient({
                    data: {
                        query: DeletePropertyMutation(property.propertyId)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error);
            }
            break;

        case LOAD_PROPERTIES_UNITS_TENANTS:
            if(!action.payload?.properties){
                action = await fetchPropertiesUnitsTenantsMiddleware(action);
            }

        }
    return next(action);
};

async function fetchProperties(dispatch, getState) {

    let properties = {};
    try {
        await graphqlClient({
            data: {
                query: GetPropertiesQuery()
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                dispatch({ type: LOAD_PROPERTIES, errors: queryResult.data.errors });
            } else {
                queryResult.data.data.userProperties.map((property) => (
                    properties[property.id] = {
                        ...parseProperty(property),
                        vacancies: property.vacancies,
                        units: {}
                    }
                ))
                let initialData = { properties };
                dispatch({ type: LOAD_PROPERTIES, payload: initialData });
            }
        })
    } catch (error) {
        console.error(error);
    }

}

async function fetchPropertiesUnitsTenants(dispatch, getState) {
    dispatch(showLoading(true));
    let properties = {};
    let units = {};
    try {
        await graphqlClient({
            data: {
                query: GetAllPropertiesUnitsTenants()
            }
        }).then((queryResult) => {
            // TODO: delete query
            if (queryResult.data.errors) {
                dispatch({ type: LOAD_PROPERTIES_UNITS_TENANTS, errors: queryResult.data.errors });
            } else {
                queryResult.data.data.allPropertyUnitsTenantsData.properties.map((property) => (
                    properties[property.id] = {
                        ...parseProperty(property),
                        vacancies: property.vacancies,
                        units: {}
                    }
                ))

                queryResult.data.data.allPropertyUnitsTenantsData.units.map((unit) => (
                    units[unit.id] = { ...parseUnit(unit) }
                ))


                for (const [key, value] of Object.entries(units)) {
                    properties[value.propertyId]["units"][value.unitId] = {}
                }

                let initialData = { properties, units };
                dispatch({ type: LOAD_PROPERTIES_UNITS_TENANTS, payload: initialData });

            }
        })
    } catch (error) {
        console.error(error);
        let initialData = { properties, units };
        dispatch({ type: LOAD_PROPERTIES_UNITS_TENANTS, payload: initialData });
        dispatch(showErrorModal(error));
    }
    dispatch(showLoading(false));
}

export {
    propertiesMiddleware,
    fetchPropertiesUnitsTenants,
    fetchProperties
}